// Shared chart styling defaults for all dashboard charts

const BAR_RADIUS = 4

// Keyed by status name (not array position) so Reservation On Going / Service On Process
// can't silently swap colors when statusSummary order changes.
export const STATUS_COLORS: Record<string, string> = {
  Completed: '#4CAF50',
  Cancel: '#F44336',
  Cancelled: '#F44336',
  'Reservation on Going': '#FF9800',
  'Service on Process': '#00BCD4'
}

// Applied to the chart's sx prop — targets legend mark rects from the SVG root
export const chartSx = {
  '& .MuiChartsLegend-mark': {
    rx: BAR_RADIUS,
    ry: BAR_RADIUS,
  }
} as const

// --- For BarCharts (vertical) ---
// slotProps.bar props are spread directly onto BarElementPath (animated SVG rect)
export const barChartSlotProps = {
  bar: { rx: BAR_RADIUS, ry: BAR_RADIUS },
  legend: {
    itemMarkWidth: 14,
    itemMarkHeight: 14,
  }
} as const

// For BarCharts with bottom-center legend (PartnerVoucherChart)
export const barChartBottomLegendSlotProps = {
  bar: { rx: BAR_RADIUS, ry: BAR_RADIUS },
  legend: {
    itemMarkWidth: 14,
    itemMarkHeight: 14,
    position: { vertical: 'bottom', horizontal: 'middle' } as const,
  }
} as const

// For LineCharts with default legend position
export const lineChartSlotProps = {
  legend: {
    itemMarkWidth: 14,
    itemMarkHeight: 14,
  }
} as const

// For LineCharts with bottom-center legend (VoucherChart)
export const lineChartBottomLegendSlotProps = {
  legend: {
    itemMarkWidth: 14,
    itemMarkHeight: 14,
    position: { vertical: 'bottom', horizontal: 'middle' } as const,
  }
} as const
